// Fetch wrapper that attaches the Supabase JWT to every API request.
import { supabase } from './supabaseClient';
import { showDemoNotice, noticeFor, DEMO_SHORT } from '../config/demo';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function request(path, { method = 'GET', body, params } = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  const url = new URL(`${BASE}${path}`);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v);
    });
  }

  const res = await fetch(url.toString(), {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  const json = text ? JSON.parse(text) : null;
  if (!res.ok) {
    // Demo build: the API refused a write. Explain it in a popup that names the
    // action, and keep the inline form message short so the two don't compete.
    if (json?.code === 'demo_read_only') {
      showDemoNotice(noticeFor(method, path));
      const err = new Error(DEMO_SHORT);
      err.code = json.code;
      throw err;
    }
    const err = new Error(json?.error || `Request failed (${res.status})`);
    err.code = json?.code; // e.g. 'mfa_required' — lets the client branch on it
    throw err;
  }
  return json;
}

export const api = {
  get: (path, params) => request(path, { params }),
  post: (path, body) => request(path, { method: 'POST', body }),
  patch: (path, body) => request(path, { method: 'PATCH', body }),
  del: (path) => request(path, { method: 'DELETE' }),
};
